import { createSlice } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';

export const initialState = {
  roles: [],
  permissions: [], // ["post:read", "post:write", …]
  expiresAt: undefined, // ms timestamp
};

const rbacSlice = createSlice({
  name: 'rbac',
  initialState,
  reducers: {
    /** Call after login/refresh */
    setToken: {
      reducer: (state, action) => {
        Object.assign(state, action.payload);
      },
      prepare: (accessToken) => {
        // Validate token before attempting to decode
        if (
          !accessToken ||
          typeof accessToken !== 'string' ||
          accessToken.trim() === ''
        ) {
          console.warn('Invalid or empty access token provided to setToken');
          return {
            payload: {
              roles: [],
              permissions: [],
              expiresAt: undefined,
            },
          };
        }

        try {
          const decoded = jwtDecode(accessToken);
          return {
            payload: {
              roles: decoded.roles ?? [],
              permissions: (decoded.scope ?? '').split(' ').filter(Boolean),
              expiresAt: decoded.exp ? decoded.exp * 1000 : undefined,
            },
          };
        } catch (error) {
          console.warn('Failed to decode JWT token:', error.message);
          return {
            payload: {
              roles: [],
              permissions: [],
              expiresAt: undefined,
            },
          };
        }
      },
    },

    /** Clear everything on logout */
    clear: () => initialState,
  },
});

export const { setToken, clear } = rbacSlice.actions;
export default rbacSlice.reducer;
